export default __webpack_public_path__ + "static/media/basemap4.ac484ea8.jpg";